import React from 'react';
import BaseCessionStatusOverlay from '@fingo/lib/features/factoring/components/overlays/BaseCessionStatusOverlay';
import SvgIconWrapper from '@fingo/lib/components/icons/SvgIconWrapper';
import InformationIcon from '@fingo/lib/assets/icons/banco-de-chile/InformationIcon';

const CessionStatusOverlay = () => (
  <BaseCessionStatusOverlay
    overlayProps={{
      IconComponent: SvgIconWrapper,
      iconProps: { Icon: InformationIcon, sx: { width: 60 } },
    }}
    titleProps={{ variant: 'medium_2', color: 'primary.A400', fontWeight: 400 }}
    bodyProps={{ variant: 'small_2', fontWeight: 400, color: 'gray.A400' }}
  />
);

export default CessionStatusOverlay;
